function isPersonName(name) {
    if (!name) {
        return false
    }
    const nonPersonKeywords = ['team', 'writers', 'agency', 'press', 'staff', 'release', 'reporter'];
    const lowerCaseName = name.toLowerCase();

    for (let keyword of nonPersonKeywords) {
        if (lowerCaseName.includes(keyword)) {
            return false;
        }
    }

    return true;
}

export default isPersonName;